import { render, staticRenderFns } from "./loginPage.vue?vue&type=template&id=8ef49856&"
import script from "./loginPage.vue?vue&type=script&lang=ts&"
export * from "./loginPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports